import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Style } from 'radium';
import { Switch } from '@lyearn-team/frontend-components';
import wistiaH from '../../../../../../../helper/wistia-helper';
import VideoTransloaditUpload from '../../../../../../components/VideoTransloaditUpload';
import EditableCaption from '../../../../components/EditableCaption';
// import Relay from 'react-relay/classic';

const styles = getStyles(); // eslint-disable-line no-use-before-define
const editorOptions = {
  disableReturn: true,
  toolbar: {
    buttons: [
      'bold',
      'italic',
      'superscript',
      'subscript',
      { name: 'justifyLeft', contentDefault: '<i class="icon-paragraph-left"></i>' },
      { name: 'justifyCenter', contentDefault: '<i class="icon-paragraph-center"></i>' },
      { name: 'justifyRight', contentDefault: '<i class="icon-paragraph-right"></i>' },
      { name: 'anchor', contentDefault: '<i class="icon-link"></i>' }
    ]
  }
};

const getMetaParsed = (meta) => {
  if (!meta) {
    return {};
  }
  if (meta && typeof JSON.parse(meta) === 'object') {
    return JSON.parse(meta);
  }
};

class MediaUploadSettings extends Component {
  static contextTypes = {
    dispatch: PropTypes.func
  };

  onSeekAheadChange = (item, blockItem) => (e) => {
    let meta = item.media.video.meta || '{}';
    meta = JSON.parse(meta);
    meta.allowSeekAhead = e.target.checked;
    meta = JSON.stringify(meta);
    this.context.dispatch('UPDATE_ITEM_MEDIA', {
      _id: item._id,
      media: {
        video: {
          src: blockItem.items[0].media.video.src,
          thumbnail: blockItem.items[0].media.video.thumbnail,
          isProcessing: false,
          meta
        }
      }
    });
  };

  onCaptionChange = itemId => (text) => {
    this.context.dispatch('UPDATE_ITEM_DATA', {
      _id: itemId,
      caption: text
    });
  };

  updateVideoThumb = (blockItem, filePickerUrl) => {
    this.context.dispatch('UPDATE_ITEM_MEDIA', {
      _id: blockItem.items[0]._id,
      media: {
        video: {
          src: blockItem.items[0].media.video.src,
          thumbnail: filePickerUrl,
          isProcessing: false,
          meta: blockItem.items[0].media.video.meta
        }
      }
    });
  };

  newUploadDone = blockItem => (filePickerUrl, type) => {
    type === 'thumbnail' && this.updateVideoThumb(blockItem, filePickerUrl);
    type === 'video' && this.uploadToWistia(blockItem, filePickerUrl);
  };

  uploadToWistia = (blockItem, filePickerUrl) => {
    fetch(`${wistiaH.uploadUrlWithAToken}&project_id=${wistiaH.projectId}&url=${filePickerUrl}`, {
      method: 'POST',
      referrer: 'no-referrer',
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    })
      .then(response => response.json())
      .then((data) => {
        const meta = getMetaParsed(blockItem.items[0].media.video.meta);
        meta.duration = data.duration || 0;
        this.context.dispatch('UPDATE_ITEM_MEDIA', {
          _id: blockItem.items[0]._id,
          media: {
            video: {
              src: 'wistiaId:' + data.hashed_id,
              thumbnail: 'wistiaInit:' + data.thumbnail.url,
              isProcessing: false,
              meta: JSON.stringify(meta)
            }
          }
        });
      });
  };

  renderSeekAheadToggle = (item, blockItem) => {
    const videoSrc = blockItem.items[0].media.video.src;
    const checked = getMetaParsed(item.media.video.meta).allowSeekAhead;
    if (!videoSrc || videoSrc.includes('wistiaId')) {
      return (
        <div style={{ marginBottom: '10px' }}>
          <Switch
            text="Allow Learner to skip ahead in the video"
            onChange={this.onSeekAheadChange(item, blockItem)}
            defaultChecked={checked}
          />
        </div>
      );
    }
  };

  renderCaption(item) {
    const caption = item.caption;

    return (
      <EditableCaption
        wrapperClassName="block-video__caption brand--body brand--linkColor brand--linkColor"
        text={caption}
        placeholder="Add a caption"
        component="figcaption"
        editable={true}
        onChange={this.onCaptionChange(item._id, this.context.dispatch)}
        editorOptions={editorOptions}
      />
    );
  }

  render() {
    const blockItem = this.props.blockItem;

    return (
      <div className="MediaUploadSettingsContainer">
        <VideoTransloaditUpload
          courseId={this.props.courseId}
          blockItem={blockItem}
          thumbUrl={blockItem.items[0].media.video.thumbnail}
          videoUrl={blockItem.items[0].media.video.src}
          uploadDone={this.newUploadDone(blockItem)}
          cardId={this.props.cardId}
        />
        {this.renderSeekAheadToggle(blockItem.items[0], blockItem)}
        {this.renderCaption(blockItem.items[0])}
        <Style rules={styles.classBased} scopeSelector=".MediaUploadSettingsContainer" />
      </div>
    );
  }
}

function getStyles() {
  return {
    classBased: {}
  };
}

export default MediaUploadSettings;
